module.exports = __webpack_public_path__ + "static/media/brewery_tank_mural_rendering_2_2007.58c96be0.webp";